import location from "@assets/data/locationLevel3"

//根据地区代码获取地区名称
export function getRegionNameByCode(code) {
  let codeStr = code + "";
  let provinceCode = codeStr.slice(0,2) + "0000";
  let cityCode = codeStr.slice(0,4) + "00";
  let areaCode = codeStr.slice(0,6);
  //省份
  let provinceObj = location.find(item => item.value === provinceCode);
  let provinceName = provinceObj?.label || "";
  //城市
  let cityObj =  provinceObj?.children?.find(item => item.value === cityCode);
  let cityName = cityObj ? ` ${cityObj.label}` : "";
  //区县
  let areaObj =  cityObj?.children?.find(item => item.value === areaCode);
  let areaName =  areaObj ? ` ${areaObj.label}` : "";
  return provinceName + cityName + areaName;
}
